// Single sign-on hand-off to the standalone PESTEL app.
//
// Regul is the identity provider. We send the user to PESTEL with our own
// opaque DRF token in the URL *fragment* — fragments are never transmitted to a
// server, so the token stays out of access logs, Referer headers and CDN
// caches. PESTEL's frontend reads it, exchanges it for its own JWT via
// `POST /api/auth/sso` (which verifies it against Regul server-side), and
// immediately strips it from the address bar.
import Config from 'config'

/**
 * URL to open PESTEL at, carrying the current session when there is one.
 *
 * Falls back to the plain PESTEL URL if the user has no token — PESTEL then
 * shows its own login page, which is the correct outcome.
 */
export function pestelSsoUrl(path = '') {
  const base = Config.pestel.url.replace(/\/$/, '') + path
  const token = localStorage.getItem('authToken')
  return token ? `${base}#sso=${encodeURIComponent(token)}` : base
}

export default pestelSsoUrl
